import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ResponsiveCheck } from 'core/providers/Responsive';
import CaretBtn from 'core/components/CaretBtn';

import MainImageWrapper from './mainImageWrapper';

import { ExternalWrapper } from './mainImageStyles';

import { RIGHT, LEFT } from './dragSlidesHoc';

class MainImage extends PureComponent {
	horizontal = dragDirection => {
		const { nextSlide, prevSlide } = this.props;
		if (dragDirection === LEFT) nextSlide();
		if (dragDirection === RIGHT) prevSlide();
	}

	render () {
		const { horizontal } = this;
		const {
			media,
			activeSlide,
			dismissVideo,
			videoIsPlaying,
			ratio,
			nextSlide,
			prevSlide,
			videoTrigger,
			listingName,
		} = this.props;
		return (
			<ResponsiveCheck>
				{({ isDesktop }) => (
					<ExternalWrapper>
						{media.length > 1 && isDesktop && (
							<CaretBtn flip center left="-24px" onClick={prevSlide} alt="Go to previous slide" />
						)}
						<MainImageWrapper
							ratio={ratio}
							horizontal={horizontal}
							media={media}
							listingName={listingName}
							activeSlide={activeSlide}
							videoIsPlaying={videoIsPlaying}
							dismissVideo={dismissVideo}
							videoTrigger={videoTrigger}
						/>
						{ media.length > 1 && isDesktop && (
							<CaretBtn center right="-24px" onClick={nextSlide} alt="Go to next slide" />
						)}
					</ExternalWrapper>
				)}
			</ResponsiveCheck>
		);
	}

	static propTypes = {
		media: PropTypes.arrayOf(PropTypes.shape({
			url: PropTypes.string.isRequired,
			name: PropTypes.string,
			isImage: PropTypes.bool,
		})).isRequired,
		activeSlide: PropTypes.number.isRequired,
		dismissVideo: PropTypes.func,
		videoIsPlaying: PropTypes.bool,
		ratio: PropTypes.string,
		nextSlide: PropTypes.func,
		prevSlide: PropTypes.func,
		videoTrigger: PropTypes.func,
		listingName: PropTypes.string,
	};
}

export default MainImage;
